import { DebugUtils } from '../../utils/debug.utils';
import { Component, Inject, OnInit } from '@angular/core';
import { EnvironmentManager } from '../../managers/environment.manager';

@Component({
  selector: 'app-debug-bar',
  templateUrl: './debug-bar.component.html',
  styleUrls: ['./debug-bar.component.scss'],
  standalone: false,
})
export class DebugBarComponent implements OnInit {
  numberOfEnvironmentParametersOverridden: number = 0;

  constructor(
    private readonly debugUtils: DebugUtils,
    private readonly environmentManager: EnvironmentManager,
    @Inject('environment.name') public readonly environmentName: string,
    @Inject('environment.production') private readonly production: boolean) {
  }

  get isDebug(): boolean {
    return this.debugUtils.isDebug();
  }

  get showEnvironmentBar(): boolean {
    return window.localStorage.getItem('do-not-show-environment-bar') !== 'true' && !this.production;
  }

  ngOnInit() {
    this.numberOfEnvironmentParametersOverridden = this.environmentManager.getOverriddenParameters().length;
  }

  activateDebug() {
    this.debugUtils.activateDebugMode();
  }

  deactivateDebug() {
    this.debugUtils.deactivateDebugMode();
  }

  doNotShowEnvironmentBar() {
    window.localStorage.setItem('do-not-show-environment-bar', 'true');
  }
}